module.exports = __webpack_public_path__ + "media/images/iconClose__okGreen-db07a7fe1c2c13867bde19e0384a65ca.png";